module.exports = __webpack_public_path__ + "img/excel.a4f2f814.svg";